<div class="fixed top-16 right-2 z-[10000] space-y-3 max-w-sm pointer-events-none">
    <div *ngFor="let toast of toasts; trackBy: trackByToastId"
        class="relative transform transition-all duration-300 ease-in-out group pointer-events-auto" [@slideIn]>

        <div class="glass-toast px-4 py-3 flex items-center justify-between gap-3 relative overflow-hidden"
            [class]="getGlobalToastClasses(toast.type)">

            <!-- Icono -->
            <div class="flex-shrink-0 z-10">
                <div [class]="getIconClasses(toast.type)" class="shadow-sm">
                    <span *ngIf="toast.type === 'success'" class="material-symbols-rounded text-base">check</span>
                    <span *ngIf="toast.type === 'error'" class="material-symbols-rounded text-base">close</span>
                    <span *ngIf="toast.type === 'warning'" class="material-symbols-rounded text-base">warning</span>
                    <span *ngIf="toast.type === 'info'" class="material-symbols-rounded text-base">info</span>
                </div>
            </div>

            <!-- Mensaje -->
            <div class="flex-1 min-w-0 z-10">
                <p class="text-[13px] font-medium tracking-wide opacity-90 mb-0.5" [class]="getTextClasses(toast.type)">
                    {{ toast.title }}
                </p>
                <p *ngIf="toast.message" class="text-xs font-base opacity-80" [class]="getTextClasses(toast.type)">
                    {{ toast.message }}
                </p>
            </div>

            <!-- Close Button -->
            <button (click)="removeToast(toast.id)"
                class="ml-2 z-10 flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
                [class]="getTextClasses(toast.type)">
                <span class="material-symbols-rounded text-lg">close</span>
            </button>
        </div>
    </div>
</div>